"use strict";

angular.module('PatientApp').factory('FeedbackService', function ($q, $resource, $rootScope, _, endpoints) {
  var Feedback = $resource(endpoints.feedback.primary.url, null, {
    feedback: {
      method: 'POST',
      url: endpoints.feedback.primary.url
    },
    options: {
      method: 'GET',
      url: endpoints.feedback.options.url
    }
  });
  return {
    // new routes for NPS feedback after payment 
    getOptions: function getOptions() {
      return Feedback.options().$promise.then(function (resp) {
        if (resp && resp.hasData()) {
          return resp.getData();
        }

        return $q.reject(resp);
      });
    },
    updateScore: function updateScore(paymentId, score, id) {
      return Feedback.feedback({
        paymentId: paymentId,
        score: score,
        id: id
      }).$promise.then(function (resp) {
        if (resp && resp.hasData()) {
          return resp.getData();
        }

        return $q.reject(resp);
      });
    },
    updateAll: function updateAll(id, paymentId, score, comment, reasons) {
      return Feedback.feedback({
        id: id,
        paymentId: paymentId,
        score: score,
        comment: comment,
        reasons: reasons
      }).$promise;
    }
  };
});